import { EmptyState } from '@synoptic/ui-kit/empty-state/empty-state.js';
import { SendDiagonalIcon } from '@synoptic/ui-kit/icons/react/send-diagonal.js';
import { TournamentCta } from '../_app.p.tournaments_.$id/tournament-cta';
import { emptyState } from './page.css';

export const EmptyTournamentSubmissions = () => {
  return (
    <EmptyState
      className={emptyState}
      illustration={<SendDiagonalIcon />}
      heading="No Submissions yet"
      description="Be the first one to submit a post to the tournament!"
      action={<TournamentCta />}
    />
  );
};
